import { useMsal } from '@azure/msal-react';
import { ICommandBarItemProps, IOverflowSetItemProps, Text, useTheme } from '@fluentui/react';
import { useBoolean } from '@fluentui/react-hooks';
import { AddIcon } from '@fluentui/react-icons-mdl2';
import { Stack } from '@fluentui/react/lib/Stack';
import { RouterParams } from 'App';
import { RootState } from 'app/store';
import CustomPanel from 'components/controls/CustomPanel';
import SimpleCard from 'components/controls/SimpleCard';
import {
    AppLinkTo,
    EViewType,
    compareUnderWritingReviewToWithoutDispatch,
    emitCustomEvent,
    styleSummary
} from 'global/Application';
import { useApplication } from 'global/Application/Context';
import { MsalTokenSource } from 'global/DataSources/MsalTokenSource';
import { removePlanFeesAndPremiumsReference, updatePlanFeesAndPremiums } from 'global/Reducer/dataSlice';
import { BuildVisibilityScope } from 'global/Visibility/GlobalVisibility';
import { IComponentContextMenu } from 'model/Application';
import * as FAM from "model/FlexibleAttributeModel";
import { useEffect, useMemo, useState } from "react";
import { ConnectedProps, connect, useDispatch, useSelector } from 'react-redux';
import { useHistory, useParams } from 'react-router';
import { AppDataSource } from '../../global/DataSources/AppDataSource';
import BlueRelationshipContext from './BlueRelationshipContext';
import FlexibleFieldView, { EScopeType } from './FlexibleFieldView';
import NonStandardTemplateWizard from './NonStandardTemplateWizard';
import NonStandardTemplateGridView from './NonStandardTemplateGridView';
import NonStandardGridView from './NonStandardGridView';
import { setProcessing } from '../../global/Reducer/statusSlice';
import saveAs from 'file-saver';
import NonStandardsGlobalGridView from './NonStandardsGlobalGridView';


interface INonStandardTemplates extends TComponentConnectedProps, IComponentContextMenu {
   // plan?: FAM.IPlan;
    //benefits?: FAM.IBenefit[];
}

const NonStandardTemplates = (props: INonStandardTemplates) => {

    //const { planId } = useParams<RouterParams>();
    const state = useSelector((state: RootState) => state);
    const disabled = props.state.status.viewType !== EViewType.Modify;

    const history = useHistory();
    const application = useApplication();

    const theme = useTheme();
    const dispatch = useDispatch();
    const [benefitWizardIsOpen, { setTrue: benefitWizardOpen, setFalse: benefitWizardClose }] = useBoolean(false);
    const [planPropertiesIsOpen, setPlanPropertiesIsOpen] = useState(false)

    const { instance } = useMsal();
    const tokenSource = new MsalTokenSource(instance);
    const dataSource = new AppDataSource(tokenSource);

    const [nonStandardTemplateWizardIsOpen, { setTrue: nonStandardTemplateWizardOpen, setFalse: nonStandardTemplateWizardClose }] = useBoolean(false);


    const workspace = props.state.status.workspace;

    const categoryPlan = props.state.data.config?.cache?.map_bcbs_config_category_named['Plan'];


    useEffect(() => {
        document.title = `Plan`;

        //if (plan?.name)
        //    document.title = `Plan | ${plan?.name}`;

    }, []);

    const contextMenu = useMemo(() => {

        const menu: ICommandBarItemProps[] = [];

        if (!disabled) {
            menu.push({
                key: 'groupConfiguration.nonStandardTemplate.add',
                name: 'Add',
                iconProps: { iconName: 'Generate' },
                onClick: (event, item) => {
                    //event?.preventDefault();
                    //event?.stopPropagation();
                    nonStandardTemplateWizardOpen();
                },
            },);
        }

        // NSE 
        menu.push({
            key: 'nse',
            text: 'Non-Standard Extract',
            title: 'Generate Non-Standard Extract',
            iconProps: { iconName: 'Generate' },
            onClick: () => {
                (async () => {
                    try {
                        dispatch(setProcessing(true));
                        const excelExtractImport = await import("global/ExcelExtract")
                        const { NonstandardExcelGeneration } = excelExtractImport;
                        const result = await NonstandardExcelGeneration(props.state, dataSource)
                        const fileName = `NSE-${props.state.data.snapshot?.bcbs_name}(${props.state.data.snapshot?.bcbs_groupconfigurationsnapshotid})-${new Date().getTime()}.xlsx`;
                        saveAs(result.file, fileName);
                    } catch (error) {
                        emitCustomEvent({
                            eventType: 'globalException',
                            details: error
                        });
                    } finally {
                        dispatch(setProcessing(false));
                    }
                })();
            }
        });
        
        return { items: menu, key: 'nsTemplates' };
    }, [disabled]);

    return <BlueRelationshipContext contextMenu={contextMenu}>
        <NonStandardTemplateWizard
            isOpen={nonStandardTemplateWizardIsOpen}
            onCancel={nonStandardTemplateWizardClose}
            onDismiss={nonStandardTemplateWizardClose}
        />
        <NonStandardTemplateGridView
            nonStandardTemplates={props.state.data.json.nonStandardTemplates}
        />
        <NonStandardsGlobalGridView />
    </BlueRelationshipContext>
}


function mapStateToProps(state: RootState) { return { state } }
const connector = connect(mapStateToProps);
type TComponentConnectedProps = ConnectedProps<typeof connector>;
export default connect(mapStateToProps)(NonStandardTemplates)